import { reportError } from "./reportError";

const LocalStoragePrefix = "pastime__";

export const LocalStorageKeys = {
  currentAppVersion: `${LocalStoragePrefix}currentAppVersion`,
  newAppVersion: `${LocalStoragePrefix}newAppVersion`,
  accessToken: `${LocalStoragePrefix}accessToken`,
  refreshToken: `${LocalStoragePrefix}refreshToken`,
  expireIn: `${LocalStoragePrefix}expireIn`,
  viewedInvitations: `${LocalStoragePrefix}viewedInvitations`,
  verificationNumber: `${LocalStoragePrefix}verificationNumber`,
  isTester: `${LocalStoragePrefix}isTester`,
  notFoundChannel: `${LocalStoragePrefix}notFoundChannel`,
  participantsIds: `${LocalStoragePrefix}participantsIds`,
  UtmData: `${LocalStoragePrefix}UtmData`,
  referrer: `${LocalStoragePrefix}referrer`,
  phoneNumberCountry: `${LocalStoragePrefix}phoneNumberCountry`,
  invitationSentBy: `${LocalStoragePrefix}invitationSentBy`,
  emitterId: `${LocalStoragePrefix}emitterId`,
  welcomeDialogShowed: `${LocalStoragePrefix}welcomeDialogShowed`,
  registrationExperiment: `${LocalStoragePrefix}registrationExperiment`,
  showPermissionDialog: `${LocalStoragePrefix}showPermissionDialog`,
  roomStatistic: `${LocalStoragePrefix}roomStatistic`,
  fastReconnect: `${LocalStoragePrefix}fastReconnect`,
  newOnboardingWelcome: `${LocalStoragePrefix}newOnboardingWelcome`,
  reloadPageIfNeeded: `${LocalStoragePrefix}reloadPageIfNeeded`,
};

export function clearLocalStorage() {
  removeFromLocalStorage(LocalStorageKeys.accessToken);
  removeFromLocalStorage(LocalStorageKeys.refreshToken);
  removeFromLocalStorage(LocalStorageKeys.expireIn);
}

export function setToLocalStorage(fieldName: string, value: string) {
  try {
    localStorage.setItem(fieldName, value);
  } catch (e) {
    reportError("localStorage.ts - setToLocalStorage.catch", "Save To Local Storage Error", e as Error);
  }
}

export function getFromLocalStorage(fieldName: string) {
  let value = "";

  try {
    value = localStorage.getItem(fieldName) || "";
  } catch (e) {
    reportError("localStorage.ts - getFromLocalStorage.catch", "Read From Local Storage Error", e as Error);
  }

  return value;
}

export function getAndParseFromLocalStorage<T>(fieldName: string, defaultValue: T): T {
  return JSON.parse(getFromLocalStorage(fieldName) || JSON.stringify(defaultValue)) as T;
}

export function removeFromLocalStorage(fieldName: string) {
  try {
    localStorage.removeItem(fieldName);
  } catch (e) {
    reportError("localStorage.ts - removeFromLocalStorage.catch", "Removing From Local Storage Error", e as Error);
    setToLocalStorage(fieldName, "");
  }
}
